import { FeatureAppLoader } from "@feature-hub/react";

// baseUrl: darunter liegen /bff/assistant und /bff/vehicle-advisor/* (lokal der Dev-Server auf 8080).
export const App = () => (
  <FeatureAppLoader featureAppId="adac:vehicle-advisor" baseUrl={process.env.BASE_URL} src="/assets/client.js" />
);
